import Modal from "../../../../../ui/Modal/Modal";
import Button from "../../../../../ui/Button/Button";
import styles from "./SaveChangesModal.module.scss";

function SaveChangesModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Unsaved changes"
      subtitle="Changes must be saved or discarded before viewing scraped webpages."
    >
      <Button
        variant="outline"
        size="small"
        onClick={onClose}
        className={styles.button}
      >
        Cancel
      </Button>
    </Modal>
  );
}

export default SaveChangesModal;
